<script setup>
import {computed, reactive, ref} from "vue";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import needsStartupsService from "@/services/needs-startups.service";
import {inject} from "vue";

const need = inject('need')
const showModal = ref(false);
const loading = ref(false);

const form = reactive({
    name: "",
    description: "",
});

const canSave = computed(() => !!form.name.length && !!form.description.length);

async function save() {
    loading.value = true;
    const {data} = await needsStartupsService.saveNeed(need.value.id, form);

    need.value.name = data.name;
    need.value.description = data.description;

    loading.value = false;
    showModal.value = false;
}

function open() {
    form.name = need.value.name;
    form.description = need.value.description;
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" modal-class="modal-w-lg" title="Edit Need">
        <form class="form">
            <div class="form__item">
                <h6 class="heading6 mb-1">Title</h6>
                <b-form-input class="form-control--mid mb-3" v-model="form.name"></b-form-input>
            </div>

            <div class="form__item">
                <h6 class="heading6 mb-1">Description</h6>
                <b-form-textarea class="form-control--mid mb-3 pt-3 pr-2" v-model="form.description" style="height: 180px"></b-form-textarea>
            </div>
        </form>

        <template #modal-footer>
            <PrimaryButton
                caption="Update Need"
                :disabled="!canSave"
                :loading="loading"
                @click="save"
            />
        </template>
    </b-modal>
</template>

<style scoped>

</style>
